import { appConfig } from '../../../../shared/app/constants/app-config';
import { uuid } from '../../../../shared/app/utils/string-utils';

export const photoStorageServiceModule = angular
  .module('Q.services.photo-storage-service', [])

  .factory('photoStorageService', function ($http, $log) {
    const uploadPhoto = ({
      dataURL,
      isBright,
      isDim,
      isStatic,
      assessmentResultId,
      teamCandidateId,
    }) => {
      // The uuid separates two photos taken in the same millisecond, which used to share a
      // Cloudinary public_id and overwrite each other.
      const currentTimeInMiliseconds = Date.now();
      const customId = `${teamCandidateId}_${assessmentResultId}_${currentTimeInMiliseconds}_${uuid().slice(-8)}`;

      // base64 overhead ~33%, so multiply by 0.75 to estimate actual bytes
      const estimatedSizeKB = (dataURL.length * 0.75) / 1024;

      const proctoringHeaders = {
        'X-Proctoring-Custom-Id': customId,
        'X-Team-Candidate-Id': teamCandidateId,
        'X-Assessment-Result-Id': assessmentResultId,
        'X-Proctoring-Estimated-Kb': String(Math.round(estimatedSizeKB)),
      };

      return $http
        .post(
          appConfig.proctoringImagesUploadRoute,
          { dataURL, customId },
          { ignoreLoadingBar: true, headers: proctoringHeaders },
        )
        .then((response) => {
          const ok = response.status === 200;
          const errorPresent = response.data && response.data.error;

          if (!ok || errorPresent) {
            throw Error(response.data.error || response.statusText);
          }

          return response.data.cloudinary;
        })
        .then((cloudinaryData) => {
          const data = {
            assessmentResultId,
            teamCandidateId,
            isBright,
            isDim,
            isStatic,
            fileId: cloudinaryData.asset_id,
            fileFormat: 'jpg',
            url: cloudinaryData.url,
          };
          return $http
            .post(appConfig.proctoringImagesRoute, { data })
            .then((response) => {
              if (response.status !== 200) {
                throw Error(response.statusText);
              }

              return response.data;
            });
        })
        .catch((error) => {
          const meta = {
            customId,
            teamCandidateId,
            assessmentResultId,
            estimatedSizeKB: Math.round(estimatedSizeKB),
          };

          if (error && typeof error.status !== 'undefined') {
            meta.status = error.status;
          }
          if (error && error.data) {
            meta.responseData = error.data;
          }

          $log.error('Error in uploadPhoto:', meta, error);
          throw error;
        });
    };

    return {
      uploadPhoto,
    };
  });
